// extracted by mini-css-extract-plugin
export default {"root":"PlasmicShinyButton_root__h6rXz","buttonDefault":"PlasmicShinyButton_buttonDefault__yxyge","signUp":"PlasmicShinyButton_signUp__LCDSN"};